import type { KeyboardEvent } from 'react';

export const CAMPAIGN_SCHEDULES_TABLE_COLUMN_COUNT = 7;
export const BRAND_ROWS_TABLE_COLUMN_COUNT = 6;

export const dropdownContentSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  px: 3,
  py: 1.5,
  width: '100%',
} as const;

export function getDropdownCellSx(isExpanded: boolean) {
  return {
    borderBottom: isExpanded ? 1 : 0,
    p: 0,
  };
}

export function toggleExpandedRow(expandedRows: Set<string>, rowId: string) {
  const nextExpandedRows = new Set(expandedRows);
  if (nextExpandedRows.has(rowId)) {
    nextExpandedRows.delete(rowId);
  } else {
    nextExpandedRows.add(rowId);
  }
  return nextExpandedRows;
}

export function handleExpandRowKeyDown(event: KeyboardEvent, onToggle: () => void) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onToggle();
  }
}
